import { useEffect, useReducer } from 'react';
import { DataReducerActions, initialDataReducerState } from 'shared/reducers';
import { adminNasEntity } from 'shared/entityDetails';
import { useRequest } from 'shared/hooks';
import adminNasReducer from 'features/networking/core/reducer';

function useAdminNAS(nasID) {
  const [
    {
      data,
      updatedData,
      dirty,
    }, dispatch,
  ] = useReducer(adminNasReducer, initialDataReducerState);
  const {
    request,
    isLoading,
  } = useRequest();

  useEffect(() => {
    if (!nasID) return;

    request(adminNasEntity.getRequest(nasID))
      .then((res) => {
        dispatch({
          action: DataReducerActions.set,
          payload: res,
        });
      });
  }, [nasID, request]);

  const get = () => new Promise((resolve) => {
    request(adminNasEntity.getRequest(nasID))
      .then((res) => {
        dispatch({
          action: DataReducerActions.set,
          payload: res,
        });
        resolve(null);
      });
  });

  const create = (body) => new Promise((resolve) => {
    request(adminNasEntity.createRequest(body), 'Created NAS')
      .then((res) => {
        if (!res?.id) return resolve(null);
        dispatch({
          action: DataReducerActions.set,
          payload: res,
        });

        return resolve(res);
      });
  });

  // Both resolve false/null on failure; request() has already shown the error.
  const update = async (body) => {
    const res = await request(adminNasEntity.updateRequest(body, nasID), 'Updated NAS');
    if (!res) return null;

    dispatch({
      action: DataReducerActions.set,
      payload: {
        ...res,
        has_tenant_rad: !!res.tenant_description,
      },
    });
    return res;
  };

  const deleteNas = async () => {
    const res = await request(adminNasEntity.deleteRequest(nasID), 'Deleted NAS');
    if (!res) return false;

    dispatch({
      action: DataReducerActions.set,
      payload: undefined,
    });
    return true;
  };

  return {
    data,
    updatedData,
    dirty,
    isLoading,
    dispatch,
    get,
    create,
    update,
    deleteNas,
  };
}

export default useAdminNAS;
